import type { MemberJoinedEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const MemberJoinedIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<circle cx="8" cy="6" r="2.5" />
		<path d="M3 13c0-2.5 2.25-4 5-4s5 1.5 5 4" />
	</svg>
)

export function MemberJoinedRow({ event }: { event: MemberJoinedEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const roleLabel = t.properties.share.roles[event.payload.role]
	return (
		<JournalRowShell
			icon={<MemberJoinedIcon />}
			headline={interpolate(t.journal.events.memberJoined.label, {
				role: roleLabel,
			})}
			actor={actor}
			iso={event.createdAt}
			eventType="member.joined"
			aria={interpolate(t.journal.events.memberJoined.aria, {
				actor,
				role: roleLabel,
			})}
		/>
	)
}
